export default __webpack_public_path__ + "982a64a8694571673a9293e3c137e115.png";